import styled from 'styled-components';
import { Dialog } from '@material-ui/core';

export const DialogBody = styled.div`
    display: grid;
    grid-auto-flow: row;
    gap: 1rem;
    width: 100%;
`;

export const DialogStyled = styled(Dialog)`
    [role='dialog'] {
        max-width: max-content;
        overflow: visible;
    }
    img {
      max-width: 100%;
      max-height: 90vh;
      object-fit: contain;
    }
`;
